<template>
  <div class="hm-home">
    <el-card>
      <div>
        {{ sendName }}
      </div>
      <div class="panel flex item-center flex-end">
        <div class="form-wrapper flex">
          <el-select
            size="small"
            clearable
            class="mr10"
            placeholder="选择券类型"
            v-model="type"
            style="width: 150px"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-date-picker
            style="width: 250px;"
            class="mr10"
            size="small"
            value-format="yyyy-MM-dd"
            placeholder="选择时间"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            v-model="sendDate"
          ></el-date-picker>
          <el-input
            class="mr10"
            size="small"
            clearable
            placeholder="输入券名"
            v-model.trim="name"
          ></el-input>
          <el-button
            size="small"
            style="margin-right: 0"
            @click="reset"
            class="hmicon icon-zhongzhi reset"
            :disabled="
              this.type === '' && this.sendDate === '' && this.name === ''
            "
          ></el-button>
          <el-button size="small" type="primary" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table">
        <div class="send-table">
          <el-table border :data="sendDetail" style="width: 100%">
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="index => index + (currentPage - 1) * pageSize + 1"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="name"
              label="规则名称"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="account"
              label="减免金额"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="折扣比率"
              prop="discount"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="sendDate"
              label="有效期"
              width="200"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="useRankFormat"
              label="使用范围"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="readme"
              label="备注"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="操作"
              width="200"
            >
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="text"
                  @click="
                    viewDetail(
                      scope.row.couponRuleId,
                      scope.row.sendWayType,
                      scope.row.name
                    )
                  "
                  >查看详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="text-center">
        <el-pagination
          background
          layout="total,sizes,  prev, pager, next, jumper"
          :total="sendDetailTotal"
          @current-change="paging"
          @size-change="handleSizeChange"
          :current-page="currentPage"

        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      couponSendId: this.$route.query.couponSendId,
      sendName: this.$route.query.sendName,
      isSendToGuider: this.$route.query.isSendToGuider,
      type: "",
      qrcodeUrl: "",
      name: "",
      sendDate: [],
      options: [
        { name: "满减券类", active: true, value: 0 },
        { name: "兑换券类", active: false, value: 1 },
        { name: "运费券类", active: false, value: 2 },
        { name: "折扣券类", active: false, value: 3 },
        { name: "服务券类", active: false, value: 4 },
        { name: "满量券类", active: false, value: 5 }
      ],
      btnList: [
        { name: "全部", active: true },
        { name: "待发布", active: false },
        { name: "发放中", active: false },
        { name: "发布成功", active: false }
      ]
    };
  },
  computed: mapState({
    sendDetail: state => state.rules.sendDetail,
    sendDetailTotal: state => state.rules.sendDetailTotal
  }),
  created() {
    this.querySendDetail();
  },
  methods: {
    reset() {
      this.type = "";
      this.sendDate = [];
      this.name = "";
    },
    viewDetail(couponRuleId, sendWayType, ruleName) {
      const name = this.sendName + "-" + ruleName;
      this.$router.push({
        name: "CouponDetail",
        query: {
          couponSendId: this.couponSendId,
          couponRuleId: couponRuleId,
          sendWayType,
          ruleName: name,
          isSendToGuider: this.isSendToGuider
        }
      });
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.querySendDetail();
    },
    paging(page) {
      this.currentPage = page;
      this.querySendDetail();
    },
    search() {
      this.currentPage = 1;
      this.querySendDetail();
    },
    querySendDetail() {
      const sendStartDate =
        this.sendDate && this.sendDate.length > 0 ? this.sendDate[0] : "";
      const sendEndDate =
        this.sendDate && this.sendDate.length > 0 ? this.sendDate[1] : "";
      this.$store.dispatch("querySendDetail", {
        type: this.type,
        name: this.name,
        sendStartDate,
        sendEndDate,
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        couponSendId: this.couponSendId
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.table {
  padding: 10px 0;
}
.qrcode-wrapper {
  text-align: center;
  img {
    width: 200px;
    height: 200px;
  }
}
.coupon-name {
  color: #4680ff;
}
</style>
